import { render, staticRenderFns } from "./poster-editor.vue?vue&type=template&id=632774ad&scoped=true&"
import script from "./poster-editor.vue?vue&type=script&lang=ts&"
export * from "./poster-editor.vue?vue&type=script&lang=ts&"
import style0 from "./poster-editor.vue?vue&type=style&index=0&id=632774ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632774ad",
  null
  
)

export default component.exports